<template>
  <div :class="!loader ? 'home home-background pt-3' : ''">
    <div class="row justify-content-center align-items-center" style="width:100vw;height:100vh" v-if="loader">
      <div class="col-1">
        <div class="spinner-border text-center" style="width: 3rem; height: 3rem;" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>       
    </div>  
    <div class="container px-5 " v-if="!loader">
      <div class="row justify-content-between " >
        <div class="col-2 col-sm-4 col-xl-3 col-lg-3 col-md-3" >
          <img class="logo-size" src="../assets/img/logo-general.svg">
        </div>
        <div class="col-4 col-sm-4 col-xl-3 col-lg-3 col-md-3">
          <img class="logo-size" src="../assets/img/new-logo-ministerio.svg" style="text-align: right;">
        </div>
        <div class="col-12 mt-4">
          <div class="line-down"></div>          
        </div>
      </div>
    </div>
    <div class="container px-5 " v-if="!loader">
      <div class="row mt-3" >
        <div class="col-12 col-sm-12 col-xl-6 col-lg-6 col-md-6">
          <p class="general-main-text">¡Hola <br> {{reponseData.name}}!</p>
        </div>       
      </div>
      <div class="row mt-2" >
        <div class="col-12 col-sm-12 col-xl-9 col-lg-9 col-md-9" >
          <p class="general-text" v-if="reponseData.application.length>0">Has realizado con éxito tu postulación al concurso Quiero Ser Maestro 7. En esta cartilla informativa te mostramos un resumen de tu postulación. </p>
          <p class="general-text" v-if="reponseData.application.length===0">Hasta el día 02 de agosto a las 1:30pm no habías seleccionado tus vacantes de preferencia en Quiero Ser Maestro 7. Este es un paso fundamental para continuar participando del concurso.</p>
        </div>
      </div>
      <div class="row mt-4" v-if="reponseData.application.length===0">
        <div class="col-12 col-sm-12 col-xl-9 col-lg-9 col-md-9" >
          <img class="logo-size-icon" src="../assets/img/clock.svg" >
        </div>
      </div>
      <div class="row mt-4" v-if="reponseData.application.length===0">
        <div class="col-12 col-sm-12 col-xl-9 col-lg-9 col-md-9" >
          <p class="general-text"><strong> Si aun no has realizado tu postulación en Quiero Ser Maestro 7, recuerda realizar la postulación a las vacantes de tu preferencia.</strong></p>        
        </div>
      </div>
      <div class="row mt-4" v-if="reponseData.application.length>0">
        <div class="col-12">
          <p class="subtitle line-down py-2">Has postulado</p>
        </div>
      </div>
       <div class="row mt-4 d-flex justify-content-center" v-if="reponseData.application.length>0">
        <div class="col-12 col-sm-12 col-xl-4 col-lg-12 col-md-12 mt-3">
          <div class="row ">
            <div class="col-12 icon-size" style="text-align: center;">
              <img class="logo-size-icon-click" src="../assets/img/Click.svg" >
            </div>
          </div>
          <div class="row">
            <div class="col-12 icon-size">
              <p class="subtitle subtitle-icon py-2">A la especialidad {{reponseData.application[0].institution.program.name}}</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-xl-4 col-lg-12 col-md-12 mt-3">
          <div class="row ">
            <div class="col-12 icon-size" style="text-align: center;">
              <img class="logo-size-icon" src="../assets/img/Escuela.svg" style="text-align: right;">
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="subtitle subtitle-icon py-2">A {{reponseData.application.length}} {{reponseData.application.length>1 ? ' instituciones educativas': ' institución educativa'}}  (I.E.)</p>
            </div>
          </div>
        </div>
      </div>
    <div class="applications">
      <div class="row mt-5 mr-3 ml-3" v-if="reponseData.application.length>0">
        <div class="col-12">
          <p class="subtitle line-down py-2">Estas son las instituciones <br>educativas a las que postulaste: </p>
        </div>
      </div>
      <div class="row mt-5 responsive" v-if="reponseData.application.length>0">
        <div class="col-12">
          <table class="table mt-4">
            <thead>        
              <tr >
                <th scope="col" role="first-col-head">Nombre de la I.E</th>
                <!-- <th scope="col" role="another-col">Idioma Ancestral</th> -->
                <th scope="col" role="another-col">Distancia al hogar*</th>
                <th scope="col" role="another-col">Tipo de sostenimiento</th>
                <th scope="col" role="another-col">Total actual de estudiantes</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(application, index) in reponseData.application" v-bind:key="application.program_id">
                <th scope="row" role="first-col-content">
                  <div class="row">
                    <div class="col-12">                     
                      <p style="font-weight: 500;"><strong>{{index+1}} {{application.institution.name}}</strong></p><br>
                    </div>
                    <div class="col-12">                     
                      <p style="font-weight: 500;"><strong>Provincia: </strong>{{application.institution.provincia}}</p>
                    </div>
                    <div class="col-12">                     
                      <p style="font-weight: 500;"><strong>Cantón: </strong>{{application.institution.canton}}</p>
                    </div>
                    <div class="col-12">
                      <p style="font-weight: 500;"><strong>Parroquía: </strong>{{application.institution.parroquia}}</p>
                    </div>
                  </div>
                </th>
                <td role="first-col-content-2" style="text-align: center;">
                  <div class="row">
                    <div class="col-12">
                      <img width="70" src="../assets/img/min-max.svg" style="text-align: center;" v-if="application.institution.distance_to_closest_town<=2">
                      <img width="120" src="../assets/img/med-max.svg" style="text-align: center;" v-if="application.institution.distance_to_closest_town>2&&application.institution.distance_to_closest_town<=10">
                      <img width="170" src="../assets/img/max-max.svg" style="text-align: center;" v-if="application.institution.distance_to_closest_town>10">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <p>{{Math.round(application.institution.distance_to_closest_town* 10) / 10}} KM</p>
                    </div>
                  </div>                                    
                </td>
                <td role="first-col-content-1">{{application.institution.private}}</td>
                <td role="first-col-content-3" style="text-align:center">{{application.institution.n_students}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row responsive" v-if="reponseData.application.length>0">
        <div class="col-12">
          <p class="reference-text py-1">* Con base al Código Único Eléctrico (CUE) de tu registro. </p>
        </div>
      </div>
       <div class="row not-responsive ml-3 mr-3" v-if="reponseData.application.length>0">
        <div class="col-12 mt-3" v-for="(application, index) in reponseData.application" v-bind:key="application.program_id">
          <!-- Via multiple directive modifiers -->
          <div v-b-toggle="application.program_id"  class="row header-responsive-table align-items-center" style="margin-left: 0px;">
            <div class="col-2 title title-first">
              {{index+1}}
            </div>
            <div class="col-10 title-second">
              {{application.institution.name}}
            </div>
          </div>            

          <!-- Elements to collapse -->
          <b-collapse :visible="true" :id="application.program_id" class="mt-1" style="margin-left:15px;width:100%">
            <div class="row mt-1 content-responsive-table size-2">
              <div class="col-12">
                <h4><strong>{{application.institution.provincia}}</strong> </h4>
                  <h4>{{application.institution.canton}}</h4>
                  <h4>{{application.institution.parroquia}}</h4>
              </div>
            </div>
            <div class="row mt-1 content-responsive-table size-3">
              <div class="col-12">
                <h4><strong>Distancia al hogar*</strong> </h4>
              </div>
              <div class="col-4">                  
                  <img width="50" src="../assets/img/min-max.svg" style="text-align: right;" v-if="application.institution.distance_to_closest_town<=2">
                  <img width="80" src="../assets/img/med-max.svg" style="text-align: right;" v-if="application.institution.distance_to_closest_town>2&&application.institution.distance_to_closest_town<=10">
                  <img width="120" src="../assets/img/max-max.svg" style="text-align: right;" v-if="application.institution.distance_to_closest_town>10">                   
              </div>
              <div class="col-3 " style="    align-self: flex-end;">
                <p>{{Math.round(application.institution.distance_to_closest_town* 10) / 10}} KM</p>
              </div>              
            </div>
            <div class="row mt-1 content-responsive-table size-1">
              <div class="col-12">
                <p><strong>Tipo de sostenimiento: </strong>{{application.institution.private}}</p>
              </div>
            </div>
            <div class="row mt-1 content-responsive-table size-1">
              <div class="col-12">
                <p><strong>Total actual de estudiantes: </strong>{{application.institution.n_students}}</p>
              </div>
            </div>
          </b-collapse>
        </div>
      </div>   
      <div class="row not-responsive ml-3 mr-3" v-if="reponseData.application.length>0">
        <div class="col-12">
          <p class="reference-text-responsive py-1">* Con base al Código Único Eléctrico (CUE) de tu registro. </p>
        </div>
      </div> 
    </div>
      <div class="row mt-5 justify-content-end blue-background" v-if="reponseData.application.length>0">
        <!-- <div class="col-3 ">
          <img class="blue-background" src="../assets/img/Ellipse92.svg" style="text-align: right;">
        </div>
        <div class="col-3">
          <img class="blue-background" src="../assets/img/Rectangle15.svg" style="text-align: right;">
        </div> -->
      </div>
      <div class="row mt-5" v-if="+reponseData.general_admission_probability>0&&+reponseData.general_admission_probability<3&&reponseData.application.length>0">       
        <div class="col-12">
          <p class="subtitle line-down py-2">¡Mejora tus posibilidades <br>de obtener una vacante!</p>
        </div>
      </div>  
      <div class="row mt-lg-5 mt-xl-5 mt-md-5 mt-sm-1 mt-1 justify-content-center" v-if="+reponseData.general_admission_probability>0&&+reponseData.general_admission_probability<3&&reponseData.application.length>0">
        <div class="col-2">
          <img class="logo-size-icon-specific" src="../assets/img/warning.svg" style="text-align: right;">
        </div>
        <div class="col-10 col-sm-10 col-xl-7 col-lg-7 col-md-7">
          <p class="general-text">Las escuelas que seleccionaste son altamente competitivas: estás compitiendo con otros aspirantes con más altos puntajes, y que tienen mayores probabilidades de obtener estas vacantes.</p>      
        </div>
      </div>  
      <div class="row mt-lg-5 mt-xl-5 mt-md-5 mt-sm-1 mt-1 justify-content-center" v-if="+reponseData.general_admission_probability>0&&+reponseData.general_admission_probability<3&&reponseData.application.length>0">
        <div class="col-2">
          <img class="logo-size-icon-specific" src="../assets/img/light.svg" style="text-align: right;">
        </div>
        <div class="col-10 col-sm-10 col-xl-7 col-lg-7 col-md-7">
          <p class="general-text" v-if="reponseData.application.length>=5">Para aumentar las posibilidades de obtener una vacante te recomendamos que cambies las instituciones educativas menos preferidas de tu lista de postulación por instituciones donde tengas mayores posibilidades de obtener una vacante.</p>
          <p class="general-text" v-if="reponseData.application.length<5">Para aumentar las posibilidades de obtener una vacante te recomendamos que añadas más instituciones educativas, donde tengas posibilidades de obtener una vacante.</p>
        </div>
      </div> 
      <div class="row mt-lg-5 mt-xl-5 mt-md-5 mt-sm-1 mt-1 justify-content-left justify-content-sm-left justify-content-md-center justify-content-xl-center justify-content-lg-center" v-if="+reponseData.general_admission_probability>0&&+reponseData.general_admission_probability<3&&reponseData.application.length>0">
        <div class="col-11 col-sm-11 col-xl-9 col-lg-9 col-md-9">
          <p class="general-text">Recuerda que los días 06 y 07 de agosto, durante el periodo de validación, puedes modificar tu postulación.</p>
        </div>
      </div> 
      <div class="row mt-lg-5 mt-xl-5 mt-md-5 mt-sm-1 mt-1 " v-if="+reponseData.general_admission_probability>0&&+reponseData.general_admission_probability<3&&reponseData.application.length>0">
        <div class="col-12">
          <p class="subtitle line-down py-2">Revisa instituciones educativas <br>que te puedan interesar</p>
        </div>
      </div>       
    </div>
    <Map
      :schools="reponseData.recommendation.institution"
      :designMode="1"
      :parentData="reponseData"
      v-if="+reponseData.general_admission_probability>0&&+reponseData.general_admission_probability<3&&reponseData.application.length>0&&!loader"
     />
    <div class="container px-5" v-if="!loader">
      <div class="row mt-lg-5 mt-xl-5 mt-md-5 mt-sm-2 mt-2 " v-if="+reponseData.general_admission_probability>0&&+reponseData.general_admission_probability<3&&reponseData.application.length>0">
        <div class="col-12">
          <p class="general-text">Estas son algunas I.E. del país donde podrías tener más posibilidades de ser asignado ya que, hasta el momento, tienen más vacantes en tu especialidad o tienen postulantes con menor puntaje que tú. </p>
          <p class="general-text">
            <strong>
              La distancia al centro poblado es la distancia en km al centro poblado más cercano de la escuela recomendada.
            </strong>
          </p>
        </div>
      </div>  
        <div class="row mt-5 responsive">
         <div class="row mt-5 responsive" v-if="+reponseData.general_admission_probability>0&&+reponseData.general_admission_probability<3&&reponseData.application.length>0">
          <table class="table mt-4">
            <thead>        
              <tr >
                <th scope="col" role="first-col-head-blue">Nombre de la I.E</th>
                <!-- <th scope="col" role="another-col">Idioma Ancestral</th> -->
                <th scope="col" role="another-col">Distancia del centro poblado más cercano</th>
                <th scope="col" role="another-col">Tipo de sostenimiento</th>
                <th scope="col" role="another-col">Total actual de estudiantes</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(recommendation, index) in reponseData.recommendation.institution" v-bind:key="recommendation.id">
                <th scope="row" role="first-col-content-blue">
                  <div class="row">
                    <div class="col-12">                     
                      <p style="font-weight: 500;"><strong>{{index+1}} {{recommendation.name}}</strong></p><br>
                    </div>
                    <div class="col-12">                     
                      <p style="font-weight: 500;"><strong>Provincia: </strong>{{recommendation.provincia}}</p>
                    </div>
                    <div class="col-12">                     
                      <p style="font-weight: 500;"><strong>Cantón: </strong>{{recommendation.canton}}</p>
                    </div>
                    <div class="col-12">
                      <p style="font-weight: 500;"><strong>Parroquía: </strong>{{recommendation.parroquia}}</p>
                    </div>
                  </div>
                </th>
                <td role="first-col-content-2" style="text-align: center;">
                  <div class="row">
                    <div class="col-12">
                      <img width="70" src="../assets/img/min-max.svg" style="text-align: center;" v-if="recommendation.distance_to_closest_town<=2">
                      <img width="120" src="../assets/img/med-max.svg" style="text-align: center;" v-if="recommendation.distance_to_closest_town>2&&recommendation.distance_to_closest_town<=10">
                      <img width="170" src="../assets/img/max-max.svg" style="text-align: center;" v-if="recommendation.distance_to_closest_town>10">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <p>{{Math.round(recommendation.distance_to_closest_town* 10) / 10}} KM</p>
                    </div>
                  </div> 
                </td>
                <td role="first-col-content-1">{{recommendation.private}}</td>
                <td role="first-col-content-3" style="text-align:center">{{recommendation.n_student}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row not-responsive" v-if="+reponseData.general_admission_probability>0&&+reponseData.general_admission_probability<3&&reponseData.application.length>0">
        <div class="col-12 mt-3" v-for="(recommendation, index) in reponseData.recommendation.institution" v-bind:key="recommendation.id">
          <!-- Via multiple directive modifiers -->
          <div v-b-toggle="recommendation.id"  class="row header-responsive-table-yellow align-items-center" style="margin-left: 0px;">
            <div class="col-2 title title-first">
              {{index+1}}
            </div>
            <div class="col-10 title-second">
              {{recommendation.name}}
            </div>
          </div>            

          <!-- Elements to collapse -->
          <b-collapse :visible="(index ===0)? true: false" :id="recommendation.id" class="mt-1 " style="margin-left:15px;width:100%">
            <div class="row mt-1 content-responsive-table-blue size-2">
              <div class="col-12">
                <h4><strong>{{recommendation.provincia}}</strong> </h4>
                <h4>{{recommendation.canton}}</h4>
                <h4>{{recommendation.parroquia}}</h4>
              </div>
            </div>
            <div class="row mt-1 content-responsive-table-blue size-3">
              <div class="col-12">
                <h4><strong>Distancia del centro poblado más cercano</strong> </h4>
              </div>
              <div class="col-4">
                <img width="50" src="../assets/img/min-max.svg" style="text-align: right;" v-if="recommendation.distance_to_closest_town<=2">
                <img width="80" src="../assets/img/med-max.svg" style="text-align: right;" v-if="recommendation.distance_to_closest_town>2&&recommendation.distance_to_closest_town<=10">
                <img width="120" src="../assets/img/max-max.svg" style="text-align: right;" v-if="recommendation.distance_to_closest_town>10">
              </div>              
              <div class="col-3 " style="align-self: flex-end;">
                <p>{{Math.round(recommendation.distance_to_closest_town* 10) / 10}} KM</p>
              </div>
            </div>
            <div class="row mt-1 content-responsive-table-blue size-1">
              <div class="col-12">
                <p><strong>Tipo de sostenimiento: </strong>{{recommendation.private}}</p>
              </div>
            </div>
            <div class="row mt-1 content-responsive-table-blue size-1">
              <div class="col-12">
                <p><strong>Total actual de estudiantes: </strong>{{recommendation.n_student}}</p>
              </div>
            </div>
          </b-collapse>
        </div>
      </div> 
      <div class="row justify-content-center margin-footer-top" v-if="+reponseData.general_admission_probability>0&&+reponseData.general_admission_probability<3&&reponseData.application.length>0">
        <div class="col-11 col-sm-11 col-xl-8 col-lg-8 col-md-8">
          <p class="subtitle" style="text-align: center;">Puedes encontrar más opciones de I.E en el portal de validación.</p>
        </div>
      </div>  
      <div class="row justify-content-center margin-footer-top" v-if="+reponseData.general_admission_probability===0&&reponseData.application.length>0">
        <div class="col-11 col-sm-11 col-xl-8 col-lg-8 col-md-8">
          <p class="subtitle" style="text-align: center;">Si quieres revisar tu postulación, puedes hacerlo durante el periodo de validación</p>
        </div>
      </div>  
      <div class="row mt-lg-5 mt-xl-5 mt-md-5 mt-sm-2 mt-2 justify-content-center align-content-center" v-if="reponseData.application.length>0">
        <div class="col-12 col-sm-12 col-xl-3 col-lg-3 col-md-3 ml-3">              
          <button class="btn btn-secondary btn-lg btn-inscription" @click="sendExternalLink()" >
            Ir al portal de validación
          </button>
        </div>
      </div> 
      <div class="row mt-lg-5 mt-xl-5 mt-md-5 mt-sm-4 mt-4 justify-content-center" v-if="reponseData.application.length>0">
        <div class="col-10 col-sm-10 col-xl-5 col-lg-5 col-md-5 ml-3">
          <p class="general-text-footer"><strong>Puedes modificar tu postulación durante el periodo de validación los días 06 y 07 de agosto.</strong></p>
        </div>
      </div>  
    </div> 
    <div class="home back-green py-5" v-if="+reponseData.application.length===0&&!loader">
      <div class="container px-5 ">
        <div class="row justify-content-center " >
          <div class="col-11 col-sm-11 col-xl-8 col-lg-8 col-md-8">
            <p class="subtitle" style="text-align: center;"><strong> El periodo de postulación de Quiero Ser Maestro 7 se cierra hoy 04 de agosto. </strong></p>
          </div>
        </div>  
        <div class="row mt-lg-5 mt-xl-5 mt-md-5 mt-sm-2 mt-2 justify-content-center">
          <div class="col-12 col-sm-12 col-xl-3 col-lg-3 col-md-3 ml-3">              
            <button class="btn btn-secondary btn-lg btn-inscription" @click="sendExternalLink2()">
              <!-- <span class="spinner-border spinner-border text-light mr-2" role="status" aria-hidden="true"></span> -->
              Ir al portal de postulación
            </button>
          </div>
        </div> 
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "../services/axios";
import Map from "../components/Map.vue";


export default {
  name: 'Home',
  components: {
    Map,
  },
  data() {
    return {
      phoneCode:'',
      reponseData: {"id":"0103224705","name":"","last_name":"null","lat":"-3.2768929","long":"-79.0532","general_admission_probability":"1.0","treatment":{"id":"1","module_1":"1","module_2":"1","module_3":"1","module_4":"1","module_5":"1","module_6":"1","module_7":"1","module_8":"1","module_9":"0"},"application":[{"institution":{"id":"01B00047","name":"Cecib De Educacion Basica Monse\u00f1or Leonidas Proa\u00f1o 1","lat":"-3.2683685","long":"-79.031761","private":"Fiscomisional","n_students":"108","language":"Kichwa","provincia":"Azuay","canton":"Nabon","parroquia":"Nabon","distance_to_closest_town":"1.8457354","program":{"id":"14","name":"Ciencias Naturales Educaci\u00f3N General B\u00e1Sica (Egb De 8Vo A 10Mo)","level":"Basica superior","vacancies":"1"}},"application_id":"2","application_ranking":"2","score_application":"51.830002","institution_id":"01B00047","admission_probability":"1.0","admission_probability_level":"null","program_id":"14"},{"institution":{"id":"01B00054","name":"Unidad Educativa Comunitaria Intercultural Bilingue Shi\u00f1a","lat":"-3.2693624","long":"-79.046249","private":"Fiscomisional","n_students":"259","language":"Kichwa","provincia":"Azuay","canton":"Nabon","parroquia":"Nabon","distance_to_closest_town":"0.95961869","program":{"id":"15","name":"Ciencias Naturales Educaci\u00f3N General B\u00e1Sica (Egb De 8Vo A 10Mo)","level":"Basica superior","vacancies":"1"}},"application_id":"2","application_ranking":1,"score_application":"51.830002","institution_id":"01B00054","admission_probability":"1.0","admission_probability_level":"null","program_id":"15"}],"recommendation":{"institution":[{"id":"01B00047","name":"Cecib De Educacion Basica Monse\u00f1or Leonidas Proa\u00f1o 1","lat":"-3.2683685","long":"-79.031761","private":"Fiscomisional","n_students":"108","language":"Kichwa","provincia":"Azuay","canton":"Nabon","parroquia":"Nabon","distance_to_closest_town":"1.8457354","vacancies":"1"},{"id":"01B00054","name":"Unidad Educativa Comunitaria Intercultural Bilingue Shi\u00f1a","lat":"-3.2693624","long":"-79.046249","private":"Fiscomisional","n_students":"259","language":"Kichwa","provincia":"Azuay","canton":"Nabon","parroquia":"Nabon","distance_to_closest_town":"0.95961869","vacancies":"1"}]}},
      loader: false,
      marker: {
         position: {
            lat: -33.4372,
            lng: -70.6572,
          }
      },
      form:{
        robot: false,
      },
    }
  },
  async mounted(){    
    const id = this.$route.query.id;
    this.loader = true;
    if (id) {
      this.showModal = false;
      await axios.get(`get/${id}`,).then(
      response => {
        if(response.status === 200){
          this.reponseData = response.data;
          if (this.reponseData.application.length !== 0) {
            this.reponseData.application.sort(function(applicationA, applicationB) {
            if(+applicationA.application_ranking > +applicationB.application_ranking) return 1;
            if(+applicationA.application_ranking < +applicationB.application_ranking) return -1;
            return 0;
          });
            // const applicationName = String(this.reponseData.application[0].institution.program.name).toLowerCase();
            // this.reponseData.application[0].institution.program.name = firstUpperCase(applicationName);
            // this.reponseData.application.forEach(application => {
            //   const institutionName = String(application.institution.name).toLowerCase();
            //   application.institution.name = firstUpperCase(institutionName);
            // })
            
          }
        }
        this.loader = false;
      })   
      }

    //   function firstUpperCase( value ) {
    //   return value.toLowerCase()
    //             .trim()
    //             .split(' ')
    //             .map( v => v[0].toUpperCase() + v.substr(1) )
    //             .join(' ');  
    //   }

    },
  methods: {
    onVerify: function (response) {
      if (response) this.form.robot = true;
    },
    async sendExternalLink(){
      window.location.href = `https://servicios.educacion.gob.ec/sgd-moe-web/faces/paginas/externo/ingresoProceso.xhtml`;
    },
    async sendExternalLink2(){
      window.location.href = `http://servicios.educacion.gob.ec/sgd-moe-web/`;
    },
    usePlace() {
      let placeSelected = this.places.filter(item=>item.Comuna === this.comunaSelected);
      this.marker = {
        position: {
          lat: placeSelected[0]['Latitud'],
          lng: placeSelected[0]['Longitud'],
        }
      }
    },
    useSpecificPlace(place) { 
      this.address = place.formatted_address
      if (place) {
        this.addressFound = true;
        this.marker = {
          position: {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          }
        }
      }
      
    },
  },
}
</script>
<style lang="scss">
html{
  overflow-x: hidden;
}

.line-down {
  border-bottom: 0.5px solid #6A5F65;
}

.back-green {
  background-color: #8ECEC7;
}

.general-main-text {
  color: #6A5F65;
  font-weight: 300;
  font-size: 80px;
  text-align: left;
  line-height: 90px;
}

.general-text {
  color: #6A5F65;
  font-weight: 400;
  font-size: 30px;
  text-align: left;
}

.general-text-final {
  color: #6A5F65;
  font-weight: 400;
  font-size: 40px;
  text-align: center;
}

.general-text-footer {
  color: #6A5F65;
  font-weight: 500;
  font-size: 30px;
  text-align: center;
}

.subtitle {
  color: #6A5F65;
  font-weight: 400;
  font-size: 40px;
  text-align: left;
}

.subtitle-icon {
  color: #6A5F65;
  font-size: 25px;
  font-weight: 300;
  text-align: center;
}

.margin-footer-top {
  margin-top:120px
}

.logo-size-icon-specific {
  width: 90px;
  text-align: center;
}

.logo-size-icon-click {
  width: 120px;
  text-align: center;
}

.logo-size-icon {
  width: 140px;
  text-align: center;
}

.icon-size{
  height: 140px;
}

.applications{
  width: 100%;
  margin-left: 0rem;
}

th[role=first-col-head] {
  height: 96px;
  font-size: 20px;
  width: 320px;
  vertical-align: middle !important;
  background-color:#0A4FBA; ;
  color: white;
}

th[role=first-col-content] {
  height: 200px;
  font-size: 20px;
  width: 320px;
  vertical-align: middle !important;
  background-color:#0A4FBA; ;
  color: white;
   margin-top: 5px  !important;
}


th[role=first-col-head-blue] {
  height: 96px;
  font-size: 20px;
  width: 320px;
  vertical-align: middle !important;
  background-color:#0052BD  ;
  color: white;
}

th[role=first-col-content-blue] {
  height: 200px;
  font-size: 20px;
  width: 320px;
  vertical-align: middle !important;
  background-color:rgba(0, 82, 189, 0.82); ;
  color: white;
   margin-top: 5px  !important;
}

.table thead th {
  border-bottom: 2px solid #8ECEC7 !important;
  border-top: 0px solid #8ECEC7 !important;
  // margin-bottom: 40px;
}

th[role=another-col] {
  height: 96px;
  font-size: 20px;
  vertical-align: middle !important;
  color:#6A5F65;
}

td[role=first-col-content-1] {
  font-size: 18px;
  font-weight: 300;
  vertical-align: middle !important;
  background-color:white; ;
  color: #6A5F65;
}

td[role=first-col-content-2] {
  font-size: 18px;
  font-weight: 300;
  vertical-align: middle !important;
  background-color:rgba(251, 225, 194, 0.1);
  color: #6A5F65;
}

td[role=first-col-content-3] {
  font-size: 30px;
  font-weight: 400;
  vertical-align: middle !important;
  background-color:rgba(251, 225, 194, 0.1);
  color: #6A5F65;
}

td[role=first-col-content-4] {
  font-size: 30px;
  font-weight: 400;
  vertical-align: middle !important;
  background-color:white;
  color: #6A5F65;
}

.table tbody th {
  border-top: 2px solid white !important;
}

.table tbody td {
  border-top: 2px solid white !important;
}

.reference-text {
  font-size: 20px;
  font-weight: 200;
  color: #333333;
}

.reference-text-responsive {
  font-size: 12px;
  font-weight: 400;
  color: #333333;
}

.header-responsive-table {
  background-color: #0A4FBA;
  color:white;
  font-weight: 700;
  width: 100%;
  min-height: 41px;
  padding: 1rem;
  vertical-align: middle;

  .title-first{
    font-size: 20px;
  }
  
  .title-second{
    font-size: 12px;
  }
}

.header-responsive-table-yellow {
  background-color: #FECD2F;
  color:black;
  font-weight: 700;
  width: 100%;
  min-height: 41px;
  padding: 1rem;
  vertical-align: middle;

  .title-first{
    font-size: 20px;
  }
  
  .title-second{
    font-size: 12px;
  }
}

.content-responsive-table-blue {
  background-color:#F2F2F2 ;
  color:#6A5F65;
  font-weight: 400;
  width: 100%;
  vertical-align: middle;

  p {
    font-size: 12px;
    vertical-align: middle;
  }

  h4 {
    font-size: 12px;
    vertical-align: middle;
  }
}

.content-responsive-table {
  background-color: white;
  color:#6A5F65;
  font-weight: 400;
  width: 100%;
  vertical-align: middle;

  p {
    font-size: 12px;
    vertical-align: middle;
  }

  h4 {
    font-size: 12px;
    vertical-align: middle;
  }
}

.size-1{
  height: 35px;
}

.size-2{
  height: 78px;
}

.size-3{
  height: 67px;
}
.responsive {
  display: block;
}

.not-responsive {
  display:none;
}

.home-background {
  background-image: url("../assets/img/Ellipse89.svg"),
  url("../assets/img/Ellipse90.svg"),
  url("../assets/img/Rectangle17.svg"),
  url("../assets/img/Rectangle12.svg"),
  url("../assets/img/Rectangle14.svg"),
  url("../assets/img/Ellipse91.svg");
  background-size:   133px, 153px, 305px, 151px, 318px, 149px, cover;
  background-repeat: no-repeat;
  background-color:   white;
  background-position: 100% 15%, 100% 100%, 0% 9%, 100% 0%, 0% 102%, 0% 37%;
  position: relative;
  height: 100%;
}

.blue-background {
  background-image: 
  url("../assets/img/Rectangle15.svg"),  
  url("../assets/img/Ellipse92.svg");
  background-size: 409px, 395px, cover;
  background-repeat: no-repeat;
  background-position: 102% 1%, 68% 100%;
  position: relative;
  height: 200px;
  width: 131%;
}

.btn-inscription{
  height: 100px;
  width: 262px;
  font-weight: 700;
  font-size: 17px;
  background-color: #333333;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
  border-color: #333333;
  color:white;
}

.btn-inscription:active{
  background-color: #4F4F4F;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}

.btn-inscription:disabled{
  background-color: #BDBDBD;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}

.logo-size {
    width:80px;
  }

@media (max-width: 576px) {
  
  .applications{
    width: 135%;
    overflow-x: hidden;
    height: 100%;
    margin: 0;
    padding: 0;  
    background-color: #E2EFFF;
    margin-left: -3rem;
  }

  .home-background {
    background-image: url("../assets/img/Ellipse89.svg"),
    url("../assets/img/Ellipse90.svg"),
    url("../assets/img/Rectangle13.svg"),
    url("../assets/img/Rectangle12.svg"),
    url("../assets/img/Rectangle14.svg"),
    url("../assets/img/Ellipse91.svg");
    background-size: 70px, 41px, 93px, 67px, 67px, 42px, cover;
    background-repeat: no-repeat;
    background-color:   white;
    background-position: 100% 8%, 100% 100%, 0% 12%, 100% 0%, 0% 94%, 0% 37%;
    position: relative;
    height: 100%;
  }

  .blue-background {
    background-image: 
    url("../assets/img/Rectangle15.svg"),  
    url("../assets/img/Ellipse92.svg");
    background-size: 165px, 178px, cover;
    background-repeat: no-repeat;
    background-position: 100% 0%, 50% 100%;
    position: relative;
    height: 104px;
    width: 100%;
  }

  .margin-footer-top {
    margin-top:30px
  }

  .responsive {
    display: none;
  }
  .not-responsive {
    display:block;
  }

  .subtitle {
    color: #6A5F65;
    font-size: 20px;
  }

  .logo-size-icon-specific {
    width: 30px;
    text-align: center;
  }

  .general-main-text {
    font-size: 30px;
    line-height: 40px;
    font-weight: 400;
  }

  .general-text {
    font-size: 15px;
  }

  .subtitle-icon {
    font-size: 15px;
    font-weight: 400;
  }

  .title-text {
    font-size: 55px;
  }

  .contact-title {
    font-size: 16px;
  }

  .form-control {
    font-size: 14px;
  }

  .form-label {
    font-size: 14px;
  }

  .general-text-response {
    font-size: 17px;
  }

  .general-text-response-center {
    font-size: 17px;
  }

  .general-text-footer {
    font-weight: 500;
    font-size: 15px;
  }

}

</style>